export default function getParameterByName(name) {
    const url = new URL(window.location.href);
    const value = url.searchParams.get(name);
    return value;
}
